/** audioLane: the ♪ Audio lane of the campaign and playlist timelines. English + Arabic (draft). */
const en = {
  "label": "Audio",
  "title": "Background audio: plays under everything above and loops",
  "loops": "Loops",
  "loopsEvery": "loops every {len}",
  "none": "No audio",
  "add": "Add background audio",
  "clickToChange": "{name}: click to change the track or mute settings",
  "remove": "Remove background audio",
  "pick": "Background audio",
  "noMatch": "Nothing matches your search.",
  "done": "Done"
};
const ar: typeof en = {
  "label": "الصوت",
  "title": "صوت في الخلفية: يُشغّل تحت كل ما سبق ويتكرر",
  "loops": "يتكرر",
  "loopsEvery": "يتكرر كل {len}",
  "none": "بلا صوت",
  "clickToChange": "{name}: انقر لتغيير المقطع أو إعدادات كتم الصوت",
  "remove": "إزالة الصوت الخلفي",
  "add": "إضافة صوت في الخلفية",
  "pick": "صوت الخلفية",
  "noMatch": "لا شيء يطابق بحثك.",
  "done": "تم"
};
export default { en, ar };
